var $3bf722b362aaf54d$exports = {};
$3bf722b362aaf54d$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \xE0 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " s\xE9lectionn\xE9");
  },
  "finishRangeSelectionPrompt": "Cliquer pour finir de s\xE9lectionner la plage de dates",
  "maximumDate": "Derni\xE8re date disponible",
  "minimumDate": "Premi\xE8re date disponible",
  "next": "Suivant",
  "previous": "Pr\xE9c\xE9dent",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Date s\xE9lectionn\xE9e\xA0: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Plage s\xE9lectionn\xE9e\xA0: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Cliquer pour commencer \xE0 s\xE9lectionner la plage de dates",
  "todayDate": function todayDate(args) {
    return "Aujourd'hui, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Aujourd\u2019hui, ".concat(args.date, " s\xE9lectionn\xE9");
  }
};
export { $3bf722b362aaf54d$exports as default };